/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for general settings by institute
 * @export
 * @interface GeneralPlanningSettingsResponse
 */
export interface GeneralPlanningSettingsResponse {
    /**
     * base unit to define appointments duration (all appointments durations will be a multiple of this value)
     * @type {number}
     * @memberof GeneralPlanningSettingsResponse
     */
    baseAppointmentDurationInMinutes?: number;
    /**
     * number of days before an appointment can be reserved
     * @type {number}
     * @memberof GeneralPlanningSettingsResponse
     */
    beforeDay?: number;
    /**
     * number of hours before an appointment can be cancelled
     * @type {number}
     * @memberof GeneralPlanningSettingsResponse
     */
    cancelHour?: number;
    /**
     * the general message displayed to the patient when they want to book an appointment
     * @type {string}
     * @memberof GeneralPlanningSettingsResponse
     */
    appointmentGeneralMessage?: string;
}

/**
 * Check if a given object implements the GeneralPlanningSettingsResponse interface.
 */
export function instanceOfGeneralPlanningSettingsResponse(value: object): value is GeneralPlanningSettingsResponse {
    return true;
}

export function GeneralPlanningSettingsResponseFromJSON(json: any): GeneralPlanningSettingsResponse {
    return GeneralPlanningSettingsResponseFromJSONTyped(json, false);
}

export function GeneralPlanningSettingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeneralPlanningSettingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'baseAppointmentDurationInMinutes': json['baseAppointmentDurationInMinutes'] == null ? undefined : json['baseAppointmentDurationInMinutes'],
        'beforeDay': json['beforeDay'] == null ? undefined : json['beforeDay'],
        'cancelHour': json['cancelHour'] == null ? undefined : json['cancelHour'],
        'appointmentGeneralMessage': json['appointmentGeneralMessage'] == null ? undefined : json['appointmentGeneralMessage'],
    };
}

export function GeneralPlanningSettingsResponseToJSON(json: any): GeneralPlanningSettingsResponse {
    return GeneralPlanningSettingsResponseToJSONTyped(json, false);
}

export function GeneralPlanningSettingsResponseToJSONTyped(value?: GeneralPlanningSettingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'baseAppointmentDurationInMinutes': value['baseAppointmentDurationInMinutes'],
        'beforeDay': value['beforeDay'],
        'cancelHour': value['cancelHour'],
        'appointmentGeneralMessage': value['appointmentGeneralMessage'],
    };
}

